import React from 'react';
import { Box } from '@mui/material';

interface ContentCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export default function ContentCard({
  title,
  subtitle,
  children,
  actions,
}: ContentCardProps) {  

  return (
    <Box className={`rounded-xl p-6 border transition flex flex-col h-full `} sx={{ backgroundColor: "background.paper", borderColor: "divider", color:"text.primary" }}>
      <div className='flex justify-between items-start gap-3 mb-4'>
        <div className=' flex-1'>
          <span className={`text-sm font-semibold block `}>{title}</span>
          {subtitle && <span className={`text-xs mt-1 block `}>{subtitle}</span>}
        </div>
        {actions && <div className='flex-shrink-0'>{actions}</div>}
      </div>
      <div className={`flex-1 overflow-y-auto max-h-48 space-y-2 `}>
        {children}
      </div>
    </Box>
  );
}
